type Props = {
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  loading?: boolean;
};
const ButtonIcon = ({ icon, loading = false }: Props) => {
  return icon && !loading && <span className="relative flex h-24 w-24 items-center justify-center">{icon}</span>;
};
export default ButtonIcon;
